import ModalContact from "@/vue/components/ModalContact";
import basePropertyForContact from "@/vue/components/basePropertyForContact";

new Vue({
    el: '#my-modal-vue',
    name: 'ModalContactManager',
    components: {ModalContact},
    data() {
        return {
            property: basePropertyForContact,
            cached: {},
        }
    },
    mounted() {
        this.obsevableClickContact()
        this.hideModal()
    },
    methods: {
        obsevableClickContact() {
            document.querySelectorAll('[data-id="modal-contact-single"]').forEach((element) => {
                element.addEventListener('click', () => {
                    const id = element.getAttribute('data-property-ad-id')
                    if (this.cached.hasOwnProperty(id)) {
                        this.property = this.cached[id]
                        const myModal = new bootstrap.Modal(document.querySelector('#modal-contact'), {})
                        myModal.toggle();
                    } else {
                        axios.post(route('api.properties.data-to-contact', id)).then(({data}) => {
                            this.property = data;
                            const myModal = new bootstrap.Modal(document.querySelector('#modal-contact'), {})
                            myModal.toggle();
                            this.cached[id] = data;
                        }).catch((e) => {
                            console.error('Failed to load contact data:', e.message)
                        })
                    }
                })
            })
        },
        hideModal(){
            const _this = this;
            const myModal = document.querySelector('#modal-contact')
            if (!myModal) return;
            myModal.addEventListener('hide.bs.modal', function () {
                _this.property = basePropertyForContact
                _this.$refs['modal-contact'].$refs.formContact.errors = []
            })
        }
    }
})
